import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { useContext } from "react";
import { ChangePasswordActionContext } from "./ChangePasswordActionContext";
import changePasswordAdmin from "@main/producers/services/changePasswordAdmin";

export default function useChangePassword() {
  const { userId, formData, setBackendFormErrors } = useContext(ChangePasswordActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    if (!userId) return;
    changePasswordAdmin(userId, formData, onSuccess, errorHandler, setBackendFormErrors);
  };
}
